// src/Navbar.js
import React from "react";
import { Link } from "react-router-dom";

function Navbar() {
  return (
    <nav className="w-full bg-white shadow-md fixed top-0 left-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <Link to="/" className="text-xl font-bold text-indigo-600">
            Diamond Coin
          </Link>

          {/* Nav Links */}
          <div className="flex space-x-6">
            <Link
              to="/"
              className="text-gray-700 hover:text-indigo-600 font-medium"
            >
              Home
            </Link>
            <Link
              to="/packages"
              className="text-gray-700 hover:text-indigo-600 font-medium"
            >
              Packages
            </Link>
            <Link
              to="/deposit"
              className="text-gray-700 hover:text-indigo-600 font-medium"
            >
              Deposit
            </Link>
            <Link
              to="/withdraw"
              className="text-gray-700 hover:text-indigo-600 font-medium"
            >
              Withdraw
            </Link>
            <Link
              to="/daily-claim"
              className="text-gray-700 hover:text-indigo-600 font-medium"
            >
              Daily Claim
            </Link>
            <Link
              to="/settings"
              className="text-gray-700 hover:text-indigo-600 font-medium"
            >
              Settings
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
